import styled from '@emotion/styled';

const FrameContainer = styled.div<{ index: number; selected: boolean }>`
    width: 150px;
    height: 120px;
    border-radius: 8px;
    padding: 3px;
    color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: pointer;

    &::after {
        display: block;
        content: '${({ index }) => index}';
        font-size: 2.5rem;
    }
`;

const FrameImage = styled.img`
    width: 100%;
    height: 85px;
    object-fit: cover;
    border-radius: 6px 6px 0 0;
`;

export default function ({ index, src, onClick, selected }: { index: number; src: string; onClick: () => void; selected: boolean }) {
    return (
        <FrameContainer index={index} onClick={onClick} selected={selected}>
            <FrameImage src={src} />
        </FrameContainer>
    );
}
